"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "shared-banner-wrapper tw pointer-events-none relative w-full overflow-hidden desktop:-top-4"
};
const _hoisted_2 = { class: "bottom-unset pointer-events-none fixed bottom-0 m-auto flex w-full max-w-[1408px] justify-center px-2 py-2 desktop:relative desktop:justify-end desktop:py-4" };
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = { class: "overflow-hidden py-4 pr-11" };
const _hoisted_5 = ["id"];
const _hoisted_6 = ["id"];
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const CloseButton_vue_1 = __importDefault(require("@SharedVueComponents/CloseButton/CloseButton.vue"));
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
const services_constants_1 = require("@ocm/services/services.constants");
const banner_query_listener_1 = require("./services/banner-query-listener");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedBanner',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const uid = (0, vue_3.ref)();
        const bannerElement = (0, vue_3.useTemplateRef)("bannerElement");
        const banner = (0, vue_3.ref)();
        const bannerFocusVisible = (0, vue_3.ref)(false);
        const bannerOpen = (0, vue_3.ref)(false);
        const iconName = (0, vue_3.computed)(() => {
            var _a;
            switch ((_a = banner.value) === null || _a === void 0 ? void 0 : _a.type) {
                case "alert":
                    return "circle-percent";
                case "success":
                    return "checkmark-circled";
                case "percent":
                    return "circle-percent";
                default:
                    return undefined;
            }
        });
        const bannerLabelId = (0, vue_3.computed)(() => `bannerLabel-${uid.value}`);
        const bannerDescriptionId = (0, vue_3.computed)(() => `bannerDescription-${uid.value}`);
        const iconClass = (0, vue_3.computed)(() => (banner.value ? `diagonal-${banner.value.type}` : ""));
        const _addBanner = (data) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            banner.value = data.data;
            if (!data.data.hideBannerFocus)
                bannerFocusVisible.value = true;
            yield (0, vue_3.nextTick)();
            uid.value = Date.now();
            bannerOpen.value = true;
            (_a = bannerElement.value) === null || _a === void 0 ? void 0 : _a.show();
            (_b = bannerElement.value) === null || _b === void 0 ? void 0 : _b.focus();
        });
        const closeBanner = () => {
            var _a, _b;
            (_a = bannerElement.value) === null || _a === void 0 ? void 0 : _a.addEventListener("animationend", _removeBanner);
            (_b = bannerElement.value) === null || _b === void 0 ? void 0 : _b.addEventListener("animationcancel", _removeBanner);
            bannerOpen.value = false;
        };
        const _removeBanner = () => {
            var _a, _b, _c;
            (_a = bannerElement.value) === null || _a === void 0 ? void 0 : _a.removeEventListener("animationend", _removeBanner);
            (_b = bannerElement.value) === null || _b === void 0 ? void 0 : _b.removeEventListener("animationcancel", _removeBanner);
            (_c = bannerElement.value) === null || _c === void 0 ? void 0 : _c.close();
            banner.value = undefined;
        };
        (0, vue_3.onMounted)(() => {
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.ADD_BANNER, _addBanner);
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.ROUTE_CHANGE, closeBanner);
            (0, banner_query_listener_1.handleSuccessfulKeycloakProcess)();
        });
        (0, vue_3.onBeforeUnmount)(() => {
            ocm_mercurius_messenger_1.default.unsubscribe(services_constants_1.messengerPublicationTypes.ADD_BANNER, _addBanner);
            ocm_mercurius_messenger_1.default.unsubscribe(services_constants_1.messengerPublicationTypes.ROUTE_CHANGE, closeBanner);
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d;
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#shared-banner-container" }, [
                (banner.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("dialog", {
                                ref_key: "bannerElement",
                                ref: bannerElement,
                                class: (0, vue_2.normalizeClass)(["ocm-body1 pointer-events-auto relative m-0 grid min-h-5 max-w-96 grid-cols-[4.8571428571rem,1fr] rounded-lg bg-gray-beton shadow focus-visible:outline-none px360:min-w-86 desktop:min-w-0", {
                                        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current': bannerFocusVisible.value,
                                        'shared-banner-animation-enter-active': bannerOpen.value,
                                        'shared-banner-animation-leave-active': !bannerOpen.value,
                                    }]),
                                tabindex: "-1",
                                "aria-label": `${(_a = banner.value) === null || _a === void 0 ? void 0 : _a.headline} ${(_b = banner.value) === null || _b === void 0 ? void 0 : _b.message}`
                            }, [
                                (0, vue_2.createVNode)(CloseButton_vue_1.default, {
                                    class: "right-1 top-1 border-transparent",
                                    style: { "background-color": "transparent !important", "width": "2.5714286rem !important", "height": "2.5714286rem !important" },
                                    inverted: "",
                                    "aria-label": (0, vue_2.unref)(t)('siteWide.sharedBanner.closeMessage'),
                                    onClick: (0, vue_2.withModifiers)(closeBanner, ["stop"])
                                }, null, 8, ["aria-label"]),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)([iconClass.value, "grid items-center rounded-l-lg px-2.5"])
                                }, [
                                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                        class: "size-7",
                                        "icon-name": iconName.value
                                    }, null, 8, ["icon-name"])
                                ], 2),
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.createElementVNode)("div", {
                                        id: bannerLabelId.value,
                                        class: "ocm-headline3 mb-1 truncate"
                                    }, (0, vue_2.toDisplayString)((_c = banner.value) === null || _c === void 0 ? void 0 : _c.headline), 9, _hoisted_5),
                                    (0, vue_2.createElementVNode)("div", {
                                        id: bannerDescriptionId.value,
                                        class: "truncate"
                                    }, (0, vue_2.toDisplayString)((_d = banner.value) === null || _d === void 0 ? void 0 : _d.message), 9, _hoisted_6)
                                ])
                            ], 10, _hoisted_3)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
